const tileUrl =
    'https://api.mapbox.com/styles/v1/wokine/clepu41pk00fe01lkuk3ec55s/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoid29raW5lIiwiYSI6ImNqbzdhdXhuZTBmeXAzcnBnZnE4bWVzMWMifQ.gRXN2yYTM-SOpyZiWk9Frg';

function getPoints(dataId, view) {
    const data = view.querySelector(`#${dataId}`);
    if (!data) return [];

    try {
        const points = JSON.parse(data.textContent);
        return Array.isArray(points) ? points : [];
    } catch (error) {
        return [];
    }
}

function addText(parent, tagName, text) {
    if (!text) return null;

    const element = document.createElement(tagName);
    element.textContent = text;
    parent.appendChild(element);
    return element;
}

function safeLink(value) {
    if (!value) return null;

    try {
        const url = new URL(value, window.location.origin);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
    } catch (error) {
        return null;
    }
}

function popupContent(point) {
    const popup = document.createElement('div');
    addText(popup, 'h3', point.title);

    const address = addText(popup, 'p', point.address);
    if (address) address.style.whiteSpace = 'pre-line';

    if (point.email) {
        const email = document.createElement('div');
        email.className = 'mailto';
        const link = document.createElement('a');
        link.href = `mailto:${point.email}`;
        link.textContent = point.email;
        email.appendChild(link);
        popup.appendChild(email);
    }

    if (point.phone) {
        const phone = document.createElement('div');
        phone.className = 'phone';
        const link = document.createElement('a');
        link.href = `tel:${point.phone.replace(/[^\d+]/g, '')}`;
        link.textContent = point.phone;
        phone.appendChild(link);
        popup.appendChild(phone);
    }

    const href = safeLink(point.link);
    if (href) {
        const button = document.createElement('a');
        button.className = 'btn';
        button.href = href;
        button.target = '_blank';
        button.rel = 'noopener noreferrer';
        button.textContent = point.button_label || 'Découvrez la programmation';
        popup.appendChild(button);
    }

    return popup;
}

export default function createEventMap(dataId, view) {
    const container = view.querySelector('#map');
    if (!container) return null;

    const points = getPoints(dataId, view);
    const map = L.map(container, {
        scrollWheelZoom: false,
        center: [50.433128, 2.82797],
        zoom: 8,
        zoomControl: false,
        maxZoom: 18,
    });

    points.forEach((point) => {
        if (!point.coordinates || point.coordinates.lat == null || point.coordinates.lng == null) return;

        const lat = Number(point.coordinates.lat);
        const lng = Number(point.coordinates.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return;

        const icon = L.icon({
            iconUrl: `${themeUrl}/dist/imgs/icons/marker.png`,
            iconSize: [30, 40],
            iconAnchor: [20, 30],
            popupAnchor: [-5, -6],
        });
        const marker = L.marker([lat, lng], { icon }).addTo(map);
        marker.bindPopup(popupContent(point));
    });

    L.tileLayer(tileUrl, {
        attribution: '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
    L.control.zoom({ position: 'bottomright' }).addTo(map);

    requestAnimationFrame(() => map.invalidateSize());
    return map;
}
